import { render, staticRenderFns } from "./tickets-page.vue?vue&type=template&id=85ea1250&scoped=true"
import script from "./tickets-page.vue?vue&type=script&lang=js"
export * from "./tickets-page.vue?vue&type=script&lang=js"
import style0 from "./tickets-page.vue?vue&type=style&index=0&id=85ea1250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ea1250",
  null
  
)

export default component.exports